import type { FieldValues, UseFormReturn } from 'react-hook-form';

/**
 * Reduces a set of fields on hook form's type.
 *
 * The TFieldValues parameter is contravariant on some methods, and types may get wrong on those.
 * For example, the `watch` method used with a callback may populate unknown keys.
 *
 * However, it is an efficient way to manage chunks of forms independently, compared to
 * implementing a fully type-safe abstraction layer.
 */
export const unsafeUseFormReturnSubset =
  <TFieldValues extends FieldValues>(form: UseFormReturn<TFieldValues>) =>
  <TKeys extends keyof TFieldValues>(): UseFormReturn<
    Pick<TFieldValues, TKeys>
  > =>
    form as any;
